import React, { useContext } from 'react';
import { AiBrand, CardTemplate, QueryIntent } from '../constants';
var UNINITIALIZED_COMMON_ATTRIBUTES = {
  cloudId: '',
  query: '',
  queryHash: '',
  baseQueryHash: '',
  source: '',
  searchSessionId: '',
  answerString: '',
  answerLength: 0,
  answerWordCount: 0,
  answerFormat: null,
  answerCardType: 'SAIN',
  sources: [],
  followUps: [],
  errorState: null,
  extraAttributes: {},
  apiSource: 'cc-search-nlp',
  workspaceId: '',
  sessionId: '',
  brand: AiBrand.AI,
  orgId: '',
  sourceProduct: ''
};
export var AIAnswerContext = /*#__PURE__*/React.createContext({
  loading: undefined,
  isAnswered: false,
  hasError: false,
  advancedSearchUrl: undefined,
  onNavigate: function onNavigate() {},
  updateContextCache: function updateContextCache() {},
  fireAnalyticsEvent: function fireAnalyticsEvent() {},
  setQuery: function setQuery() {},
  setData: function setData() {},
  userDetails: {},
  disclaimer: null,
  commonAttributes: UNINITIALIZED_COMMON_ATTRIBUTES,
  initialCollapsed: undefined,
  liked: undefined,
  setLiked: function setLiked() {},
  likesDisabled: false,
  setLikesDisabled: function setLikesDisabled() {},
  initialReported: undefined,
  isReadingAids: false,
  cardProviderProps: undefined,
  baseQuery: undefined,
  smartAnswersRoute: QueryIntent.DEFAULT,
  cardTemplate: CardTemplate.DEFAULT,
  brand: AiBrand.AI,
  answerEditor: undefined,
  closeParentDialog: function closeParentDialog() {}
});
export var useAIAnswerContext = function useAIAnswerContext() {
  return useContext(AIAnswerContext);
};